// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1YAn1","unreadBadge":"styles_unreadBadge__2bhPe","modalContent":"styles_modalContent__1JGK5","modal":"styles_modal__VkjuQ"};